import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import {AuthService} from '../../../core/auth/auth.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import * as config from "../../../../../config.json";

@Component({
  selector: 'app-auth-sec',
  templateUrl: './auth-sec.component.html',
  styleUrls: ['./auth-sec.component.css']
})
export class AuthSecComponent implements OnInit {

  url: SafeResourceUrl;
  link:any;
  filler: string;
  dashboardurl: string;
  loader: boolean;
  constructor(private route: ActivatedRoute, 
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: Document,) { }

    ngOnInit() { 
      let userId;
      let token;
      let status;
      let userName;
      let state;
     // this.dashboard();
      this.route.queryParams
        .filter(params => params.filler)
        .subscribe(params => {
         this.filler = params.filler;
         console.log(this.filler); 
        }
      );
      const updateBody = {
        email: this.filler,
        password : "1234"
     }
     this.loader = true;

      this.authService.login((updateBody))
      .subscribe(
          data=>{ 
                    this.loader = false;
                    userName = data['CREATED_BY'];
                    userId = data['USER_ID']; 
                    status = data['message'];
                    state = data['messages']                   
                    localStorage.setItem('userid', userId);
                    localStorage.setItem('name', userName); 
                    if(status === "Login Success"){
                      this.dashboard();
                    }
                    else if(state === "Login Failed user not in table"){
                      this.backToNS();
                    }
          },
          
      );
      
    }​​​​​​​​
    dashboard(){
      this.dashboardurl = "/cqm-ns" ;
      this.router.navigate([this.dashboardurl]);
    }
    backToNS(){
      this.document.location.href = config['scriptlessHome'];
    }
  }



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/auth-sec/auth-sec.component.ts